var configs = {
    scrollOffset: 0,
    updateOffset: 50
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/pagescroll/_configs.js
// module id = 513
// module chunks = 0